import React, { useState } from "react";
import { AccessibleFocusOutline } from "./AccessibleFocusOutline";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";

export const ConfirmationButton = ({
	onClick,
	variant,
	textOverride,
	showIcon = true,
	smaller = false,
	disabled,
	text,
}) => {
	const [buttonDisabled, setButtonDisabled] = useState(true);

	const toggleCheckbox = () => {
		setButtonDisabled(!buttonDisabled);
	};
	const variantClasses = () => {
		let ret;
		switch (variant) {
			case "active":
				ret = `min-w-32 text-sm py-2.5 rounded-full ${
					buttonDisabled
						? "text-gray-500 bg-gray-100 cursor-default"
						: "text-white bg-black cursor-pointer"
				} font-bold`;
				break;

			case "inactive":
			default:
				ret = `min-w-32 text-sm py-2.5 rounded-full border ${
					buttonDisabled
						? "text-gray-500 bg-gray-100 cursor-default"
						: "text-black bg-white cursor-pointer"
				}`;
				break;
		}

		return ret;
	};

	return (
		<div className="grid justify-items-center">
			<div onClick={toggleCheckbox} className="md:mb-2">
				<span>{text || "Please confirm"}: </span>
				{buttonDisabled ? (
					<FaRegSquare
						size={24}
						className="mr-4 cursorPointer inline text-gray-600"
					/>
				) : (
					<FaRegCheckSquare
						size={24}
						className="mr-4 cursorPointer inline text-gray-600"
					/>
				)}
			</div>
			<AccessibleFocusOutline classes={"w-auto"}>
				<button
					className={`${variantClasses()} `}
					onClick={onClick}
					disabled={buttonDisabled}
				>
					<span className="font-bold">{textOverride ?? "Back"}</span>
				</button>
			</AccessibleFocusOutline>
		</div>
	);
};
